import styled from 'styled-components/macro';
import { fontSize } from '../../styles/mixins';
import media from '../../styles/media';

export const ModalTitle = styled.h1`
  ${({ hasIcon }) => (hasIcon ? fontSize(26) : fontSize(16))};
  ${({ hasIcon }) => hasIcon || 'font-weight: 500;'}
  ${({ hasIcon }) => hasIcon || 'line-height: 2.13;'}
  color: ${({ theme, hasIcon }) =>
    hasIcon ? theme.primaryColor : theme.modalTitleColor};
  ${media.desktop`
  ${({ hasIcon }) => (hasIcon ? fontSize(26) : fontSize(20))};

  `}
`;
